import { getV4EditorRoute } from 'FormsUI/lib/RouteGenerators';
const redirectToNewEditor = (id, creationType) => {
  window.location.replace(getV4EditorRoute(id, creationType));
};
export default redirectToNewEditor;